/**
 * PeriodBanner.jsx : en tête de l'analyse quand une période est appliquée.
 * Dit ce qui est analysé (bornes avec la date, durée sur celle de la
 * session, mesures retenues), rappelle que les seuils sont des références sur
 * 24 h, et porte les avertissements de periodAnalysis.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTheme } from '../../constants/theme';
import { semanticColors } from '../../constants/semanticColors';
import { periodBannerText, periodWarningTexts, retainedText } from './periodText';

export default function PeriodBanner({ analysis, darkMode = false }) {
  const { t } = useTranslation();
  if (!analysis?.active) return null;
  const theme = getTheme(darkMode);
  const warnings = periodWarningTexts(analysis, t);

  return (
    <section data-testid="period-banner" role="status"
      style={{ borderRadius: '12px', padding: '14px 16px', marginBottom: '16px',
        background: darkMode ? 'transparent' : semanticColors.blueBg,
        border: `1px solid ${theme.border}`, color: theme.textPrimary }}>
      <p data-testid="period-banner-range" style={{ margin: 0, fontSize: '14px', fontWeight: '700' }}>
        {periodBannerText(analysis, t)}
      </p>
      <p data-testid="period-banner-retained" style={{ margin: '4px 0 0', fontSize: '13px', color: theme.textSecondary }}>
        {retainedText(analysis, t)}
      </p>
      <p data-testid="period-banner-reference" style={{ margin: '4px 0 0', fontSize: '12px', fontStyle: 'italic', color: theme.textSecondary }}>
        {t('session.period.reference24h')}
      </p>
      {warnings.map(({ key, text }) => (
        <p key={key} data-testid={`period-warning-${key}`}
          style={{ margin: '6px 0 0', fontSize: '13px', fontWeight: '500',
            color: darkMode ? semanticColors.amberSolid : semanticColors.amberText }}>
          {text}
        </p>
      ))}
    </section>
  );
}
